var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthTableLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.002,
    height: 48.855,
    viewBox: "0 0 30.002 48.855",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_357",
    "data-name": "Rectangle 357",
    width: 29.99,
    height: 15.682,
    fill: "#17447e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_358",
    "data-name": "Rectangle 358",
    width: 14.998,
    height: 33.745,
    fill: "#17447e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_360",
    "data-name": "Rectangle 360",
    width: 14.998,
    height: 21.129,
    fill: "#17447e"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_361",
    "data-name": "Rectangle 361",
    width: 15.004,
    height: 21.129,
    fill: "#17447e"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040",
    transform: "translate(-9.999 -12.832)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1018",
    "data-name": "Group 1018",
    transform: "translate(9.999 30.895)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1017",
    "data-name": "Group 1017"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M25,25.527,10,32.348l15,8.861,14.991-8.861Z",
    transform: "translate(-10 -25.527)",
    fill: "#17447e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1021",
    "data-name": "Group 1021",
    transform: "translate(9.999 12.832)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1019",
    "data-name": "Group 1019",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M10,37.715l15,8.861V12.832Z",
    transform: "translate(-10 -12.831)",
    fill: "#17447e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1024",
    "data-name": "Group 1024",
    transform: "translate(24.997 12.832)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1023",
    "data-name": "Group 1023"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1022",
    "data-name": "Group 1022",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M20.541,12.832V46.576l14.991-8.861Z",
    transform: "translate(-20.54 -12.831)",
    fill: "#17447e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1027",
    "data-name": "Group 1027",
    transform: "translate(9.999 40.557)",
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1026",
    "data-name": "Group 1026"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1025",
    "data-name": "Group 1025",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M10,32.319,25,53.448V41.179Z",
    transform: "translate(-10 -32.318)",
    fill: "#17447e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1030",
    "data-name": "Group 1030",
    transform: "translate(24.997 40.557)",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1029",
    "data-name": "Group 1029"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1028",
    "data-name": "Group 1028",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M20.541,41.179V53.448l15-21.129Z",
    transform: "translate(-20.54 -32.318)",
    fill: "#17447e"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthTableLogo);
export default __webpack_public_path__ + "static/media/ethTableLogo.6b561d9f7ca6862c0e0fb1fb8d287a87.svg";
export { ForwardRef as ReactComponent };